import React from "react";
import { string } from "prop-types";
import { useLocale } from "@insightfulscience/i18";
import {
	ShareDownloadsButton,
	ShareDownloadsButtonCol,
} from "@insightfulscience/atomic-react/r1/molecules/ShareDownloads";

const ShareDownloadLinkItem = ({ os, downloadLink }) => {
	const [t] = useLocale("share-downloads-links");
	return (
		<ShareDownloadsButtonCol>
			<ShareDownloadsButton href={`${downloadLink}`} iconName={os}>
				{t(`${os.toUpperCase()}.TITLE`)}
			</ShareDownloadsButton>
		</ShareDownloadsButtonCol>
	);
};

ShareDownloadLinkItem.propTypes = {
	os: string,
	downloadLink: string,
};

export default ShareDownloadLinkItem;
